import { get } from "lodash";

import { FilterFieldOptionsHookResult } from "~/features/filter";
import {
  DealerStatus,
  useGetMyDealersQuery,
} from "~/schemas/generated/graphql";

/**
 * Опции дилерских центров для фильтра DNM — те же данные, что грузил
 * старый FilterDNM (активные дилеры текущего пользователя).
 */
export const useDnmDealerOptions = (): FilterFieldOptionsHookResult => {
  const { data, loading } = useGetMyDealersQuery({
    variables: {
      page: 0,
      partName: null,
      count: 20000,
      statuses: DealerStatus.Active,
    },
    fetchPolicy: "no-cache",
  });

  const items = get(data, "DealerGetter.getMyDealers.items", []) as Array<{
    id: string | number;
    DealerName: string;
  }>;

  return {
    options: items.map(({ id, DealerName }) => ({
      value: String(id),
      label: DealerName,
    })),
    loading,
  };
};
